import type { WikiNavigationData, WikiPage } from '@/types/wiki'

const API_BASE = import.meta.env.VITE_API_BASE || ''

async function fetchJSON<T>(url: string): Promise<T> {
  const res = await fetch(`${API_BASE}${url}`)
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}: ${res.statusText}`)
  }
  return res.json()
}

export async function getNavigation(): Promise<WikiNavigationData> {
  return fetchJSON('/api/wiki/categories')
}

export async function getPages(): Promise<WikiPage[]> {
  return fetchJSON('/api/wiki/pages')
}

export async function getPageBySlug(slug: string): Promise<WikiPage> {
  return fetchJSON(`/api/wiki/pages/${encodeURIComponent(slug)}`)
}

export async function searchPages(query: string): Promise<WikiPage[]> {
  return fetchJSON(`/api/wiki/search?q=${encodeURIComponent(query)}`)
}

export async function getPageByPreviewToken(token: string): Promise<WikiPage> {
  return fetchJSON(`/api/wiki/pages/preview/${encodeURIComponent(token)}`)
}
